/* eslint-disable max-len */
import * as React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

export const OfficeLifeIcon = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg viewBox="0 0 20 21.76" aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M13.11,9.58h1.12a2,2,0,0,1,1.58.88,3.7,3.7,0,0,1,0,4.22,2,2,0,0,1-1.58.87H13.07" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M.86,7.21h12a.36.36,0,0,1,.36.36V16a2.24,2.24,0,0,1-2.24,2.24H2.74A2.24,2.24,0,0,1,.5,16V7.57A.36.36,0,0,1,.86,7.21Z" fill="#d8f0e9" stroke="#666" />
        <path d="M8.33.5l.94.79a.76.76,0,0,1,.22.28.8.8,0,0,1,.07.34.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79A.77.77,0,0,0,8,4a.84.84,0,0,0,.07.35.85.85,0,0,0,.22.28l.58.49" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.76.5l.94.79a.76.76,0,0,1,.22.28A.8.8,0,0,1,6,1.91a.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79a.76.76,0,0,0-.22.28A.77.77,0,0,0,4.46,4a.82.82,0,0,0,.3.63l.58.49" fill="none" stroke="#666" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
